module.exports = __webpack_public_path__ + "img/collection.21db66cc.png";